import { conversationHistoryTexts } from './crm.conversation.constant';

export const agendaQueueSize = 10;

export const agendaPageSize = agendaQueueSize + 1;

export const agendaPollingMs = 30000;

export const heroLeaveDurationMs = 420;

export const agendaActivityTypes = {
    call: 'call',
    message: 'message',
}

export const lastInteractionTypes = {
    call: 'call',
    message: 'message',
    contactReply: 'contact_reply',
}

export const agendaChannelByActivityType = {
    [agendaActivityTypes.call]: { label: 'Ligação', actionLabel: 'Ligar para contato', alternateActionLabel: 'Ligar por telefone' },
    [agendaActivityTypes.message]: { label: 'Mensagem', actionLabel: 'Enviar mensagem', alternateActionLabel: conversationHistoryTexts.actionLabel },
}

const getActivityTypeLabel = (type) => agendaChannelByActivityType[type]?.label || 'Atividade';

export const agendaAlternateActivityType = {
    [agendaActivityTypes.call]: agendaActivityTypes.message,
    [agendaActivityTypes.message]: agendaActivityTypes.call,
}

export const agendaWorkTypes = {
    schedule: 'schedule',
    return: 'return',
    approach: 'approach',
    followUp: 'follow_up',
}

export const agendaWorkTypeChipByType = {
    [agendaWorkTypes.schedule]: { label: 'Agendamento', tone: 'amber' },
    [agendaWorkTypes.return]: { label: 'Retorno', tone: 'green' },
    [agendaWorkTypes.approach]: { label: 'Abordagem', tone: 'blue' },
    [agendaWorkTypes.followUp]: { label: 'Follow-up', tone: 'neutral' },
}

export const agendaTexts = {
    eyebrow: 'Gestto',
    title: 'Agenda do dia',
    explanationLink: 'Saiba mais sobre a agenda do dia',
    nowSectionLabel: 'Agora',
    queueSectionLabel: 'Próximas',
    queueLockNote: 'Conclua a atividade atual para liberar a próxima',
    getQueueHiddenNote: (count) => `+ ${count} ${count === 1 ? 'oportunidade' : 'oportunidades'}`,
    emptyTitle: 'Você está em dia',
    emptyDescription: 'Nenhuma atividade pendente. Novas oportunidades entram automaticamente assim que distribuídas.',
    errorTitle: 'Não foi possível carregar a agenda',
    errorAction: 'Tentar novamente',
    discardLabel: 'Descartar',
    discardHint: 'Remove o contato do CRM e impede novas oportunidades.',
    markAsLostLabel: 'Perdida',
    openOpportunityLabel: 'Ver detalhes',
    concludeLabel: 'Concluir atividade',
    concludingLabel: 'Concluindo...',
    lateChipLabel: 'Atrasado',
    firstContactLabel: 'Primeiro contato',
    noInteractionLabel: 'Sem interação recente',
    objectiveTitle: 'Objetivo',
    contactRepliedTitle: 'Cliente respondeu',
    contactRepliedFallback: 'O contato respondeu — retome a conversa.',
    stageFactLabel: 'Etapa',
    abandonedCartFactLabel: 'Carrinho abandonado',
    lastPackageFactLabel: 'Último pacote',
    balanceFactLabel: 'Saldo atual',
    getRecentUsageFactLabel: (days) => `Uso em ${days} dias`,
    noPackageLabel: 'Nenhum pacote',
    noRecentUsageLabel: 'Nenhum serviço',
    getVoucherLabel: (code) => `cupom ${code}`,
    getServicesCountLabel: (count) => `${count} ${count === 1 ? 'serviço' : 'serviços'}`,
    getPetitionsCountLabel: (count) => `${count} ${count === 1 ? 'petição' : 'petições'}`,
    getCalculationsCountLabel: (count) => `${count} ${count === 1 ? 'cálculo' : 'cálculos'}`,
    lastInteractionFactLabel: 'Último contato',
    descriptionTitle: 'Descrição',
    workedMetricLabel: 'oportunidades trabalhadas',
    conversionMetricLabel: 'de conversão',
    revenueMetricLabel: 'de receita',
    monthToDateMetricSuffix: 'no mês',
    myOpportunitiesLabel: 'Minhas oportunidades',
    newOpportunityLabel: 'Nova oportunidade',
    pageTitlePrefix: 'CRM - ',
    getAheadTitle: (dayLabel) => `Agenda de ${dayLabel}`,
    getAheadEmptyTitle: (dayLabel) => `Nada na agenda de ${dayLabel}`,
    getWeekendReason: (weekday) => `Hoje é ${weekday}.`,
    getHolidayReason: (holidayName) => holidayName ? `Hoje é feriado (${holidayName}).` : 'Hoje é feriado.',
    getAheadNotice: (reason, dayLabel) => `${reason} Você está vendo a agenda de ${dayLabel}.`,
    getAheadActivityLabel: (dayLabel) => `Prevista para ${dayLabel}`,
    getWaitingChipLabel: (type, time) => `${getActivityTypeLabel(type)} às ${time}`,
    getWaitingNotice: (type, time) => `${getActivityTypeLabel(type)} recomendada a partir das ${time}, para manter a distância da atividade anterior.`,
    getWaitingRecommendationLabel: (time) => `Recomendada a partir das ${time}`,
}

export const nonWorkingDayReasons = {
    weekend: 'weekend',
    holiday: 'holiday',
}

export const lastInteractionLabelByType = {
    [lastInteractionTypes.call]: 'Ligação',
    [lastInteractionTypes.message]: 'Mensagem enviada',
    [lastInteractionTypes.contactReply]: 'Respondeu',
}
